export default {
    CREATE_TASK: () => `/task/createTask`,

    CREATE_CONTACT_TASK: () => `/taskContact`,
    GET_TASK: (query) => `/task/getAllTask?${query}`,
    UPDATE_TASK: (id) => `/task/updateTask/${id}`,
    GET_ALL_DELETED_TASK: () => `/getAllDeletedTask`,
    GET_TASK_BY_ID: (id) => `/task/getTaskBy/${id}`,
    DELETE_TASK: (id) => `/task/deleteTask/${id}`,
    UPDATE_CHILD_TASK: (parentId) => `/task/updateParentTask/${parentId}`,
    GET_TRAVEL_BY_TASK: (id, query) => `/travellerDetails/getByTaskId/${id}?${query}`,

    GET_TASK_CONTACT_BY_ID: (id) => `/taskContact/getByTaskId/${id}`,

    UPDATE_TASK_GMAIL_WHATSAAP: (id) => `/task/updateTask/${id}`,

    GET_ALL_TASK: (id) => `/task/getAllDateTask?boardId=${id}`,

    // await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data)

    // UPD: (id) => `/updateStatusTask/${id}`,
    MOVE_TASK_DRAG_DROP: () => `/task/updateItemsDisplayOrder`,
    TASK_LINK_DATA: () => `/emailLink`,
    GET_TASK_LINK_DATA: (id) => `/emailLink/${id}`,
    DELETE_TASK_ATTACHEMENT: (id, attachId) => `/task/${id}/attachments/${attachId}`,

    // Task Dependency APIs
    GET_ALL_DEPENDENCIES: () => `/taskDependency`,
    CREATE_DEPENDENCY: () => `/taskDependency`,
    DELETE_DEPENDENCY: (id) => `/taskDependency/${id}`,
};
